<template src="./index.html"></template>

<script>
import {getdata} from "./data.js";
import {queryCompanyList} from "../../../../../../api/home.js";
import config from "../../../../../../../configHttp.js";
import invoiceDetail from "./invoiceDetail/index.vue";
import autoApportion from "./autoApportion/index.vue";

export default {
  components: {invoiceDetail,autoApportion},
  data: function () {
    return {
      headData: getdata().headData,
      searchdiag: false,
      searchlist: getdata().searchlist,
      searchdata: getdata().searchdata,
      tableData: [{
        id: 12345678,
        companyCode: "1100",
        suosq: "123",
        faplx: "",
        faphm: "0987654321",
        jzjtbs: "",
        weisjehj: 0,
        shuiehj: 0,
        jzjtxse: 0,
        tuisse: 0,
        financialAnnotations: "",
        beiz: "进项发票测试",
        goufmc: "",
        goufsbh: "",
        createTime: "",
        kaiprq: "",
        jzjtUpdateBy: "",
        isLock: "",
        jzjtsuosq: ""
      }],
      pagination: getdata().pagination,
      tablekey: 0,
      overlength: 0,
      invoiceDetailDiag: false,
      invoiceDetailDiagTitle: "",
      invoiceId: -1,
      manualAllocationFlag: false,
      autoApportionDiag: false,
    };
  },
  mounted() {
    this.loadHeadData()
  },
  created() {
    this.fetchBillDetails();
  },
  methods: {
    loadHeadData() {
      queryCompanyList().then(res => {
        if (res.data.code === 1) {
          let companyCodeVal = [];
          for (let i = 0; i < res.data.data.length; i++) {
            companyCodeVal.push({label: res.data.data[i].companyCode, value: res.data.data[i].companyCode})
          }
          this.searchlist[2].selectval = companyCodeVal;
          this.searchlist = JSON.parse(JSON.stringify(this.searchlist));
        } else {
          this.$message.error(res.data.msg)
        }
      });
    },
    fetchBillDetails() {
      let params = JSON.parse(JSON.stringify(this.searchdata));
      params.current = this.pagination.pageNum;
      params.size = this.pagination.pageSize;
      params.sort = "createTime";
      params.order = "desc";
      // xxzzs_mxquery(params).then((res) => {
      //   this.pagination.total = res.data.data.total;
      //   this.pagination.paginationkey++;
      //   this.tableData = res.data.data.records;
      // });
    },
    getInvoice() {
      this.$message.info("获取发票");
    },
    setApportionMethod(value) {
      let chooseItem = this.$refs.tablebox.getSelectionval();
      if (this.$emptyandnull(chooseItem)) {
        this.$message.error("请选择数据");
        return false;
      }
      if (value === "4") {
        if (chooseItem.length > 1) {
          this.$message.error("请选择一条数据");
          return false;
        }
        this.manualAllocationFlag = true;
        this.openInvoiceDetailDiag(chooseItem[0]);
      }
    },
    autoApportion() {
      this.$message.info("一键分摊");
      this.autoApportionDiag = true;
    },
    closeAutoApportionDiag() {
      this.autoApportionDiag = false;
    },
    cancelRequisition() {
      this.$message.info("取消即征即退");
    },
    outPutIInvResult() {
      let selectVal = this.$refs.tablebox.getSelectionval();
      let data = {};
      if (selectVal.length > 0) {
        data.ids = selectVal.map((item) => item.id);
      } else {
        data.fapiaoInfoSearchExtendInputDTO = JSON.parse(JSON.stringify(this.searchdata));
      }
      let params = {
        downUrl: config.baseURL + "oinv/details/export",
        typeObj: {
          toForm: false,
          fileName: "销项增值税票据明细" + this.$timestampToStr(new Date(), "yyyyMMdd"),
          fileType: "xlsx",
          failUrl: this.$winURl
        },
        params: data,
      };
      this.$downloadcommon(params);
    },
    delInvoice() {
      this.$message.info("删除");
    },
    geOoverLength(e) {
      this.overlength = e;
    },
    closeSearch() {
      this.searchdiag = false;
    },
    saveChange(e) {
      this.searchdiag = false;
    },
    forUpdateSearch() {
      this.searchdiag = true;
    },
    sizechange(e) {
      this.pagination.pageSize = e;
      this.fetchBillDetails();
    },
    currentChange(e) {
      this.pagination.pageNum = e;
      this.fetchBillDetails();
    },
    submitSearch() {
      this.pagination.pageNum = 1;
      this.pagination.paginationkey++;
      this.fetchBillDetails();
    },
    openInvoiceDetailDiag(e) {
      this.invoiceDetailDiagTitle = "发票明细(" + e.faphm + ")";
      this.invoiceId = e.id;
      this.invoiceDetailDiag = true;
      this.$refs.childRef.findDate(this.invoiceId);
    },
    closeInvoiceDetailDiag() {
      this.invoiceDetailDiag = false;
      this.manualAllocationFlag = false;
    },
  },
};
</script>

<style scoped lang="less">
@import url("./index.less");
</style>
